import { ApiTags, rootApi } from '../../../../services/rootApi';
import { IServiceReqApprovalPay } from '../models';

const TAG = ApiTags.ServiceReqApprovalPayment;
const getTags = (entities: IServiceReqApprovalPay[]) => [...entities.map((p) => ({ type: TAG, id: p.id })), TAG]

const serviceReqApprovalsApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    getServiceReqApprovals: builder.query<IServiceReqApprovalPay[], string>({
      query: (requestId) => `/ApprovalCardSerReqPay/${requestId}`,
      providesTags: (result) => result ? getTags(result) : [TAG]
    }),
  })
})

export const {
  useGetServiceReqApprovalsQuery,
  useLazyGetServiceReqApprovalsQuery,
} = serviceReqApprovalsApi;